import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CfetPageNamesConstant, CfetBaseComponent } from '../../../cfet-core';

@Component({
    selector: 'app-customer-documents-review',
    templateUrl: './customer-documents-review.component.html',
    styleUrls: ['./customer-documents-review.component.scss'],
    standalone: false
})
export class CustomerDocumentsReviewComponent extends CfetBaseComponent implements OnInit {

  @Output() setNewSession = new EventEmitter<any>();
  constructor(private router: Router) { super(); }

  ngOnInit() {
    window.scrollTo(0, 0);
  }

  continueToProfile(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.router.navigate([CfetPageNamesConstant.CUSTOMER_PROFILE]);
      this.setNewSession.emit(true);
    }
  }

}
